import { MajorCourseMapViewContentComponent } from './components/major_coursemap_view_content/major_coursemap_view_content_controller';
import { MajorDetailViewContentComponent } from './components/major_detail_view_content/major_detail_view_content_controller';
import { MajorDevCoursesViewContentComponent } from './components/major_dev_courses_view_content/major_dev_courses_view_content_controller';
import { MajorSearchViewContentComponent } from './components/major_search_view_content/major_search_view_content_controller';
import { MajorSortFilterComponent } from './components/major_sort_filter/major_sort_filter_controller';
import { MajorTileComponent } from './components/major_tile/major_tile_controller';
import { MajorTileCareerComponent } from './components/major_tile_career/major_tile_career_controller';
import { MajorTileCareersListComponent } from './components/major_tile_careers_list/major_tile_careers_list_controller';
import { SurveyBeginViewContentComponent } from './components/survey_begin_view_content/survey_begin_view_content_controller';
import { SurveyQuestionChoiceComponent } from './components/survey_question_choice/survey_question_choice_controller';
import { SurveyQuestionGenericComponent } from './components/survey_question_generic/survey_question_generic';
import { SurveyQuestionListSelectionComponent } from './components/survey_question_listselection/survey_question_listSelection_controller';
import { SurveyQuestionMetarankingComponent } from './components/survey_question_metaranking/survey_question_metaranking_controller';
import { SurveyQuestionProgramsComponent } from './components/survey_question_programs/survey_question_programs_controller';
import { SurveyQuestionRankComponent } from './components/survey_question_rank/survey_question_rank_controller';
import { SurveyStepFooterComponent } from './components/survey_step_footer/survey_step_footer';
import { SurveyStepViewContentComponent } from './components/survey_step_view_content/survey_step_view_content_controller';
import { SurveyStepService } from './data/services/survey_step_service';
import { SurveyAboutDataModalComponent } from './modals/about_data_modal/survey_about_our_data_modal';
import { SurveyProgramResultModalComponent } from './modals/about_program_results_modal/survey_about_program_results_modal';
import { SurveyMetarankingModalComponent } from './modals/metaranking_modal/survey_metaranking_modal';
import { SurveyInterestModalComponent } from './modals/view_interests_modal/survey_view_your_interests_modal';

import { MajorCredentialsViewContentComponent } from './components/major_credentials_view_content/major_credentials_view_content_controller';
import { MajorExplorerCapabilityConfiguration } from './configuration';
import './data/major_explorer_data_module';
import { MetaRankingModalService } from './modals/metaranking_modal/metaranking_modal_service';
import { MyMajorExplorerRoutes } from './routes';
import { MajorCourseMapController } from './views/major_course_map/major_course_map_controller';
import { MajorDetailController } from './views/major_detail/major_detail_controller';
import { MajorPlacementscoresController } from './views/major_placement_scores/major_placement_scores_controller';
import { MajorSurveyBeginController } from './views/major_survey_begin/major_survey_begin_controller';
import { MajorSurveyStepController } from './views/major_survey_step/major_survey_step_controller';

angular
  .module('capability-ng-major-explorer', ['major-explorer-data'])
  .component('surveyBeginContent', new SurveyBeginViewContentComponent())
  .component('majorCourseMapContent', new MajorCourseMapViewContentComponent())
  .component('majorDetailContent', new MajorDetailViewContentComponent())
  .component('majorDevCoursesContent', new MajorDevCoursesViewContentComponent())
  .component('surveyStepFooter', new SurveyStepFooterComponent())
  .component('majorTile', new MajorTileComponent())
  .component('majorTileCareer', new MajorTileCareerComponent())
  .component('majorTileCareerList', new MajorTileCareersListComponent())
  .component('surveyQuestionChoice', new SurveyQuestionChoiceComponent())
  .component('surveyQuestionGeneric', new SurveyQuestionGenericComponent())
  .component('surveyQuestionListselection', new SurveyQuestionListSelectionComponent())
  .component('surveyQuestionMetaranking', new SurveyQuestionMetarankingComponent())
  .component('surveyQuestionRank', new SurveyQuestionRankComponent())
  .component('surveyQuestionPrograms', new SurveyQuestionProgramsComponent())
  .component('majorSearchContent', new MajorSearchViewContentComponent())
  .component('surveyStepContent', new SurveyStepViewContentComponent())
  .component('majorSortFilter', new MajorSortFilterComponent())
  .component('surveyAboutDataModal', new SurveyAboutDataModalComponent())
  .component('surveyProgramResultModal', new SurveyProgramResultModalComponent())
  .component('surveyMetarankingModal', new SurveyMetarankingModalComponent())
  .component('surveyInterestModal', new SurveyInterestModalComponent())
  .component('majorCredentialsContent', new MajorCredentialsViewContentComponent())
  .service('ngSurveyStepService', SurveyStepService)
  .service('ngMajorExplorerCapabilityConfiguration', MajorExplorerCapabilityConfiguration)
  .service('ngMetaRankingModalService', MetaRankingModalService)
  .controller('MajorSurveyBeginController', MajorSurveyBeginController)
  .controller('MajorSurveyStepController', MajorSurveyStepController)
  .controller('MajorDetailController', MajorDetailController)
  .controller('MajorCourseMapController', MajorCourseMapController)
  .controller('MajorPlacementscoresController', MajorPlacementscoresController)
  .config(MyMajorExplorerRoutes);

require('./components/survey_question/survey_question_directive');
require('./components/phx_delegate_tag/delegate_tag_component');



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/capability_ng_major_explorer_module.ts